var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{style:('width: 100% !important; height: 100% !important; max-height: 100%; overflow-y: scroll; overflow: hidden;' +
    (_vm.soMetaBackgroundColorCard
      ? 'background-color: ' + _vm.soMetaBackgroundColorCard
      : ''))},[_c('v-toolbar',{staticStyle:{"background":"transparent"},attrs:{"dense":"","flat":""}},[_c('v-toolbar-title',{style:(_vm.soMetaTextColorTitle ? 'color: ' + _vm.soMetaTextColorTitle : '')},[_vm._v(_vm._s(_vm.module.title))])],1),_c('vue-friendly-iframe',{staticStyle:{"max-height":"100%"},attrs:{"src":_vm.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }